import { Column } from 'primereact/column';
import { DataTable } from 'primereact/datatable';
import React, { useEffect, useState } from 'react';

import './scorecardPayRules.scss';
import { useGetEmployeePayRuleTenureDetailsQuery } from './scorecardPayRulesSlice';

interface propTypes {
    inputMonth: number;
    inputYear: number;
    inputScorecardVersion: number;
    inputEmployeeNumber?: number;
    inputScorecardRoleId?: number;
}
export const ScorecardPayRules = ({ inputMonth, inputYear, inputScorecardVersion, inputEmployeeNumber, inputScorecardRoleId }: propTypes) => {
    const [employeeRole, setEmployeeRole] = useState<string>('');
    const { data: scorecardPayrulesData } = useGetEmployeePayRuleTenureDetailsQuery(
        {
            employeeNumber: inputEmployeeNumber,
            year: inputYear,
            month: inputMonth,
            scorecardVersionId: inputScorecardVersion,
            scorecardRoleId: inputScorecardRoleId,
        },
        { skip: !inputEmployeeNumber || !inputYear || !inputMonth || !inputScorecardVersion || !inputScorecardRoleId }
    );
    useEffect(() => {
        if (inputScorecardRoleId === 1)
            setEmployeeRole('Agent');
        else if (inputScorecardRoleId === 2)
            setEmployeeRole('TeamLead');
    }, [inputScorecardRoleId]);
    const renderHeader = () => {
        return (
            <div className="headerAgent">
                {employeeRole}
            </div>
        );
    };
    const maxMetricPayoutPercentageTemplate = (rowData: any) => {
        const payout = rowData?.max_metric_payout;
        const payoutPercentage = payout * 100;
        return <span className="image-text">{payoutPercentage?.toFixed(2)}%</span>;
    };
    const maxMetricMinusOnePayoutTemplate = (rowData: any) => {
        const payout = rowData?.max_minus_1_payout;
        const payoutPercentage = payout * 100;
        return <span className="image-text">{payoutPercentage?.toFixed(2)}%</span>;
    };
    return (
        <div className="card my-4 borderRadius10">
            <div className="card-body pb-2">
                <h6 className="card-title">Pay Rules</h6>
                <hr className="my-0" />
                <div className="row mt-2 mb-2">
                    {inputScorecardRoleId ? (
                        <div className="col-md-12">
                            <DataTable
                                value={scorecardPayrulesData?.data}
                                responsiveLayout="scroll"
                                className="payRulesTable"
                                header={renderHeader}
                                dataKey="payout_tenure_name"
                            >
                                <Column field="payout_tenure_name" header="Tenure" className="fontSize14" />
                                <Column field="max_minus_1_payout" body={maxMetricMinusOnePayoutTemplate} header="#Metric Met Max-1" className="fontSize14" />
                                <Column field="max_metric_payout" body={maxMetricPayoutPercentageTemplate} header="#Metric Met Max" className="fontSize14" />
                            </DataTable>
                        </div>
                    ) : (
                        <div>No Results Found</div>
                    )}
                </div>
            </div>
        </div>
    );
};
